<template>
    <div>
        <header-page></header-page>
        <full-page :options="options" id="fullpage">
            <div class="section" id="section0">
                <div class="slide" id="location">
                </div>
            </div>
            <div class="TitleBottom"><a
                    @click="$vuetify.goTo('#welcome',{ duration:1000, offset:0, easing:'easeInOutCubic'})">
                <h1>
                    <v-icon :size="screenwidth" color="white">mdi-chevron-down</v-icon>
                    Location de matériel traiteur
                </h1>
            </a></div>
        </full-page>
        <div>
            <div class="backgroundGreen" id="welcome">
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-8 col-lg-8" style="background:#848388;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h2 class="display-5 bottomH2">Location de matériel de cuisine, de mobilier et
                                            de vaisselle</h2>
                                        <p>
                                            Nous assurons la location de matériel pour les particuliers comme pour les
                                            professionnels, pour toutes sortes de réceptions : mariages, anniversaires,
                                            séminaires, foires, salons, etc.

                                        </p>
                                        <p>
                                            Lorsque vous assurez vous-même l’organisation de votre événement, le
                                            matériel est à enlever et à rapporter dans nos locaux de Nomexy, près de
                                            Charmes, à l’adresse suivante :<br>
                                        <div>
                                            <div class="adresseLocation">10 rue de l’Estrey<br>
                                                88440 NOMEXY
                                            </div>
                                        </div>
                                        </p>
                                        <p>Bien sûr, lorsque nous sommes le traiteur de votre événement, nous nous
                                            occupons de tout !</p>
                                        <p class="tarifLocation">Nos tarifs de location sont indiqués par jour et toutes
                                            taxes comprises (TTC), sauf mention contraire.</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/location/location-couverts.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/location/location-couverts.jpg" alt="Location de matériel traiteur"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/location/location-couverts.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/location/rotissoire-cochon.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/location/rotissoire-cochon.jpg" alt="Rotissoire à cochon"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/location/rotissoire-cochon.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-8 col-lg-8" style="background:#a97b5b;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-5 bottomH2">Location de matériel culinaire</h3>
                                        <p class="pAlpha">
                                        <ul>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                <b> Bain-marie & 2 pâtes de chauffage</b> : 20 €<br>
                                                Les pâtes de chauffage vous permettent de chauffer des plats partout,
                                                sans électricité.
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                <b> Machine à fondue au chocolat</b> : 40 €
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                <b> Rôtissoire à cochon et agneau</b> : 150 €<br>
                                                Cette rôtissoire professionnelle est idéale pour un méchoui, un
                                                sanglier, un cochon de lait, etc.<br>
                                                Elle est prévue pour des repas de 30 à 120 personnes.
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                <b> Remorque frigorifique</b> : 100 € (150 € pour un weekend
                                                complet)<br>
                                                Pour la location de la remorque frigorifique, merci de prévoir une
                                                attache-remorque.<br>
                                                Nous vous demanderons un certificat d’assurance de votre véhicule en
                                                cours de validité (carte verte), lors de la signature du contrat de
                                                location.
                                            </li>
                                        </ul>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-8 col-lg-8" style="background:#804626;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-5 bottomH2">Location de mobilier</h3>
                                        <p class="pAlpha">
                                        <ul>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                <b> Mange debout </b> : 30 €<br>
                                                Ce prix inclut le pressing pour la housse reprise en l’état après
                                                l’événement.<br>
                                                Les housses de nos mange-debout sont disponibles en 4 coloris : vert,
                                                blanc, noir et gris.
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                <b> Flûte à champagne</b> : 0,50 €
                                            </li>

                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            <b> Jeu de 3 verres pour l'apéritif</b> : (champagne, soft & vin) : 1,00 €
                                        </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                <b> Jeu de vaisselle simple</b> : 4 €<br>
                                                3 assiettes + 2 jeux de couverts + 2 verres (soft & vin)
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                <b> Jeu de vaisselle avancé</b> : 5 €<br>
                                                3 assiettes + 3 jeux de couverts + 3 verres (soft, vin blanc & rouge)
                                            </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            <b> Jeu de vaisselle prémium</b> : 6 €<br>
                                            4 assiettes + 4 jeux de couverts + 3 verres (soft, vin blanc & rouge)
                                        </li>
                                        </ul>
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/location/location-fontaine-chocolat.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/location/location-fontaine-chocolat.jpg" alt="Rotissoire à cochon"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/location/location-fontaine-chocolat.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-page> </footer-page>
    </div>

</template>

<script>
    import HeaderPage from './headerPage'
    import FooterPage from './footerPage'

    export default {
        name: 'location',
        components: {
            HeaderPage,
            FooterPage
        },
        data() {
            return {
                options: {
                    licenseKey: 'A32C7F42-F0FE4A04-AAB7E182-AB1F9C8B',
                    navigation: false,
                    scrollBar: true,
                    autoScrolling: false,
                    fitToSection: false
                }
            }
        },
        methods: {
            afterLoad() {
                console.log('After load')
            },
        },
        computed: {
            screenwidth() {
                if (screen.width > 400) {
                    return 70
                } else {
                    return 30
                }
            }
        },
        created() {
            document.getElementsByTagName('meta')["description"].content = "Le traiteur Croustillance, installé près de Charmes, assure aussi la location de matériel de cuisine, de mobilier et de vaisselle, pour particuliers et professionnels..";
            document.title = "Location de matériel de cuisine, de mobilier et de vaisselle";
        }
    }
</script>

<style>
    .adresseLocation {
        padding: 10px;
        text-align: center;
        font-size: 30px;
        font-family: 'Nunito', sans-serif;
        font-weight: bold;
    }

    .tarifLocation {
        background-color: #95c01e;
        padding: 10px;
        text-align: center;
        font-size: 22px;
        font-family: 'Nunito', sans-serif;
        font-weight: bold;
        border-radius: 10px;
    }
    #location {
        background: url('/img/location/location-materiel.jpg') no-repeat center center;
        padding: 0 0 0 0;
        background-size: cover;
    }
</style>
